import {IntegrationMessage} from "platform/integration/message/IntegrationMessage";
import {IntegrationClassId} from "platform/integration/message/IntegrationClassId";

export class IntegrationReload implements IntegrationMessage {

    public classId: number = IntegrationClassId.RELOAD;

}
